// extracted by mini-css-extract-plugin
module.exports = {"list":"product-features_list__qj84X","check":"product-features_check__r0Kr7"};